import React, { useState } from "react";
import { getWindowSize } from "../../helper/helper";
import { useEffect } from "react";

const ScrollTop = () => {
  const [show, setShow] = useState(false);

  window.addEventListener("scroll", (e) => {
    const scrolled = document.documentElement.scrollTop;

    if (scrolled > 600) {
      setShow(true);
    } else {
      setShow(false);
    }
  });

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed ${
        show ? "opacity-100 visible scale-100" : "opacity-0 invisible scale-0"
      } lg:left-20 left-7 bottom-24 w-11 h-11 bg-yellow-600 hover:opacity-80 transition-all duration-300 shadow-lg rounded-xl flex justify-center items-center group !z-[99999]`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-6 h-6 stroke-white"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8.25 6.75 12 3m0 0 3.75 3.75M12 3v18"
        />
      </svg>
    </button>
  );
};

export default ScrollTop;
